import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import { useTranslation } from 'react-i18next';

interface IProps {
	changeNameOfPortion: (value: string) => void;
}

export const NamePortionInput: React.FC<IProps> = React.memo(({ changeNameOfPortion }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterPortionName') }], [t]);

	return (
		<FormInput
			testId="NamePortionInput"
			name="nameOfPortion"
			label="portionNameLabel"
			onChange={changeNameOfPortion}
			validationRules={validationRules}
			maxLength={100}
		/>
	);
});
